(function () {
  var host2id = {
    "es.toproset.eu": "22894999339357",
    "nl.toproset.eu": "22903490773341",
    "en.toproset.eu": "22903562273117",
  };

  // Попробуем прочитать залогиненного из window.Shopify.customer (если тема его выдаёт)
  var snippetCustomerId =
    window.Shopify && Shopify.customer && Shopify.customer.id
      ? Shopify.customer.id
      : host2id[window.location.host] || null;

  console.log("▶️ snippetCustomerId (JS-only):", snippetCustomerId);

  if (snippetCustomerId) {
    window.Spurit = window.Spurit || {};
    window.Spurit.QuantityBreaks2 = window.Spurit.QuantityBreaks2 || {};
    window.Spurit.QuantityBreaks2.snippet =
      window.Spurit.QuantityBreaks2.snippet || {};
    Spurit.QuantityBreaks2.snippet.customer = { id: snippetCustomerId };
    Spurit.QuantityBreaks2.snippet.use_customer_default_address = true;
  }
})();
